import Icons from '../../constants/Icons'
import './style.css'
const AboutUs = () => {
  return (
    <div>
      <div
        className='AboutUs-Banner'
        style={{ backgroundImage: `url(${Icons.AboutUs})` }}
      >
        <div className='About-Container'>
          <h3 className='text-capitalize text-bold '>About Us</h3>
          <p>
            At Arrshiyana Tours & Travels, we focus on transforming corporate
            travel into a seamless experience characterized by precision and
            reliability. Our services encompass comprehensive travel solutions,
            including flight bookings, hotel arrangements, and visa processing,
            tailored to the unique demands of businesses.
          </p>
          <p>
            Driven by professionalism and a dedication to excellence, we serve
            as your reliable partner, enabling your business to flourish by
            alleviating the burdens of travel. With Arrshiyana Tours & Travels,
            you're not merely traveling; you're arriving, connecting, and
            achieving your goals.
          </p>
        </div>
      </div>

      <section>
        <div className='container'>
          <div className='Our-Key-Services'>
            <section className=''>
              <div className=''>
                <div className='why-aadesh'>
                  <h3 className='text-capitalize text-bold '>
                    Our Key Services
                  </h3>
                  <div className='row p-2'>
                    <div className='col-lg-8 pb-3' style={{ width: '100%' }}>
                      <div className='row pl-3 '>
                        {[
                          {
                            name: 'Air Booking',
                            title:
                              'Travel smoothly with our dependable air booking services, offering competitive rates for both domestic and international flights to ensure timely and budget-friendly journeys.',
                            Icons: Icons.Are
                          },
                          {
                            name: 'Hotel Booking',
                            title:
                              'Enjoy comfort during your travels with our hotel booking services, which connect you to a selection of accommodations tailored to your preferences and budget.',
                            Icons: Icons.hotel
                          },
                          {
                            name: 'Visa Assistance',
                            title:
                              'Simplify the complex visa process with our dedicated team, who manage paperwork, appointments, and follow- ups to ensure timely visa acquisition.',
                            Icons: Icons.visa
                          },
                          {
                            name: 'Travel Insurance',
                            title:
                              'Travel confidently with our comprehensive travel insurance, providing coverage for unexpected events and ensuring your safety and financial security.',
                            Icons: Icons.travel
                          },
                          {
                            name: 'Car Rental',
                            title:
                              'Ensure efficient ground transportation for your trips with our car rental services, offering a diverse range of vehicles for both local and intercity travel.',
                            Icons: Icons.car
                          }
                        ].map((items, index) => (
                          <div key={index} className='col-sm-6'>
                            <div className='d-flex align-items-start presence-our'>
                              <div className='icon-box'>
                                <img src={items.Icons} />
                              </div>
                              <div className='corporate-our'>
                                <h5>{items.name}</h5>
                                <p>{items.title}</p>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </section>
    </div>
  )
}
export default AboutUs
